export const HELP_CATEGORY_INFO = {
  formTitle: "Help Category",
  formTitleForNew: "New Help Category",
  path: "/helpcategories",
  listPage: "/help-categories",
}

// Must stay in sync with Kaliber-UI's CATEGORY_ICONS map
// (Kaliber-UI/src/pages/help-center/help-center-icons.js) and Admin-API's
// ALLOWED_ICON_KEYS (Kaliber-Admin-API/src/services/help-category.service.js)
// — icons are React components, staff pick from this fixed list.
const ICON_KEY_OPTIONS = [
  { value: "sales", label: "Sales" },
  { value: "purchasing", label: "Purchasing" },
  { value: "inventory", label: "Inventory" },
  { value: "manufacturing", label: "Manufacturing" },
  { value: "hr", label: "HR" },
  { value: "project", label: "Project" },
  { value: "finance", label: "Finance" },
  { value: "reports", label: "Reports" },
  { value: "settings", label: "Settings" },
]

export const HELP_CATEGORY_FORM_TEMPLATE = {
  bodySections: {
    basic: {
      sectionType: "basic",
      sectionTypeId: "BASIC",
      expandable: false,
      breakPoint: 2,
      fieldName: "helpCategory",
      fieldItems: [
        {
          label: "Label",
          type: "text",
          name: "label",
          initialFocus: true,
          validationProps: {
            required: "Label is required",
          }
        },
        {
          label: "Icon",
          type: "select-sync",
          name: "iconKey",
          required: false,
          initialFocus: false,
          options: ICON_KEY_OPTIONS,
          validationProps: {
            required: "Icon is required",
          }
        },
        {
          label: "Sort Order",
          type: "text",
          name: "sortOrder",
          initialFocus: false,
        },
      ]
    },
  },
  watchFields: []
}
